module.exports = {"Name":"EtiquetasDetailView","TitleKey":"ETIQUETAS","Type":"DetailView","Model":"Etiquetas","CustomDetail":true}